import APICall from "../utils/APICall";

export default class CustomerServices {
  static listCustomers = async (
    page,
    pageLimit,
    search,
    from,
    to,
    registrationStage
  ) => {
    var url = `/api/Customer/admin/listCustomers?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (from) url = `${url}&from=${from}`;
    if (to) url = `${url}&to=${to}`;
    if (registrationStage)
      url = `${url}&registrationStage=${registrationStage}`;
    return await APICall(url, "GET");
  };
  static getSummary = async () => {
    return await APICall("/api/Customer/admin/customers-summary", "GET");
  };
  static viewCustomer = async (userName) => {
    return await APICall(`/api/Customer/admin/viewCustomer/${userName}`, "GET");
  };
  static viewCustomerBvn = async (bvn) => {
    return await APICall(
      `/api/Customer/admin/viewCustomerBvn?bvn=${bvn}`,
      "GET"
    );
  };
  static blockCustomer = async (userName) => {
    return await APICall(
      `/api/Customer/admin/block-customer`,
      "POST",
      userName
    );
  };
  static unLockCustomer = async (payload) => {
    return await APICall(
      "/api/Customer/admin/unlock-customer",
      "POST",
      payload
    );
  };
  static UnBlockCustomer = async (payload) => {
    return await APICall(
      "/api/Customer/admin/unblock-customer-profile",
      "POST",
      payload
    );
  };
  static unblockAccount = async (accountNumber) => {
    return await APICall(
      `/api/Customer/admin/unblock-customer-account/`,
      "POST",
      accountNumber
    );
  };
  static syncBVN = async (payload) => {
    return await APICall(
      "/api/Customer/admin/sync-bvnDetails",
      "POST",
      payload
    );
  };
  static bnvDetailsSync = async (payload) => {
    return await APICall(
      "/api/BvnDetails/admin/bvnDetails-sync",
      "POST",
      payload
    );
  };
  static listSettings = async (userName) => {
    return await APICall(
      `/api/Customer/admin/list-settings?userName=${userName}`,
      "GET"
    );
  };
  static blockAccount = async (userId) => {
    return await APICall(
      "/api/Customer/admin/block-customer-accounts",
      "POST",
      userId
    );
  };
  static verficationMail = async (payload) => {
    return await APICall(
      "/api/Customer/admin/resend-mail-verification",
      "POST",
      payload
    );
  };
  static exportList = async (search, from, to, registrationStage) => {
    return await APICall(
      `/api/Customer/admin/export-customers?search=${search}&from=${from}&to=${to}&registrationStage=${registrationStage}`,
      "GET"
    );
  };
  static exceptionalLimit = async (payload) => {
    var formData = new FormData();
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });
    return await APICall(
      "/api/Customer/admin/assign-exceptional-limit",
      "POST",
      formData
    );
  };
  static rejectExceptionLimit = async (payload) => {
    return await APICall(
      "/api/Customer/admin/reject-exceptional-limit",
      "POST",
      payload
    );
  };
  //    security features
  static securityMode = async (payload) => {
    return await APICall(
      "/api/Customer/admin/disable-customer-security-modes",
      "POST",
      payload
    );
  };
  static resetProfile = async (payload) => {
    return await APICall(
      `/api/Customer/admin/customer-profile-reset`,
      "POST",
      payload
    );
  };
  static exportNewToBank = async () => {
    return await APICall(`/api/admin/export-new-to-bank`, "GET");
  };
  static updateCustomerLimit = async (username, payload) => {
    return await APICall(
      `/api/Customer/admin/customer/limit/${username}`,
      "POST",
      payload
    );
  };
  static rejectCustomerLimit = async (username) => {
    return await APICall(
      `/api/Customer/admin/customer/reject/limit/${username}`,
      "POST"
    );
  };
  static setDefaultLimit = async (payload) => {
    return await APICall(
      `/api/Customer/admin/set-default-limit`,
      "POST",
      payload
    );
  };
  static clearCustomerCache = async (payload) => {
    const url = `/api/Customer/admin/clear-customer-cache-data`;
    return await APICall(url, "POST", payload);
  };

  static GetReviews = async (
    application,
    pageIndex = 1,
    pageSize = 10,
    startDate = "",
    endDate = ""
  ) => {
    return await APICall(
      `/api/Customer/admin/view-paginated-ratings?application=${application}&pageIndex=${pageIndex}&pageSize=${pageSize}&startDate=${startDate}&endDate=${endDate}`,
      "GET"
    );
  };

  static ClearAllApplicationData = async () => {
    const url = `/api/Customer/admin/purge-all-application-cache-data`;
    return await APICall(url, "POST");
  };
}
